export default {
  install: Vue => {
    // nav
    Vue.component('tabbing-nav', require('./tapping-nav').default)
  },
}
